module.exports = __webpack_public_path__ + "img/bgGif2.59c1052f.gif";